"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Initializer = void 0;
var _analyticsState = require("./analytics-state");
var _gasv = require("./gasv3");
var _gtmIntegration = require("./gtm-integration");
var _helpers = require("./helpers");
var _metrics = require("./metrics");
var _tracking = require("./tracking");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Module for initializing the wrapper.
 * @module Initializer
 */
var Initializer = exports.Initializer = /*#__PURE__*/function () {
  function Initializer() {
    _classCallCheck(this, Initializer);
  }
  return _createClass(Initializer, null, [{
    key: "initWithPageAnalytics",
    value:
    /**
     * Initializes auto-tracking and page view tracking.
     * @function initWithPageAnalytics
     * @param {string} writeKey - required, historically used as Segment.io key, now just sent as a property (not sure if used, but keep sending it)
     * @param {object} pageViewProperties - optional, dictionary of properties of the page
     * @param {number} loadTimestamp - optional, the timestamp at which the initializing site loaded this script
     * @param {string} anonymousId - GASv3 analytics client anonymous id
     * @param {function} createAnalyticsEvent - analytics-next CreateUIAnalyticsEvent
     */
    function initWithPageAnalytics(writeKey) {
      var pageViewProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var loadTimestamp = arguments.length > 2 ? arguments[2] : undefined;
      var anonymousId = arguments.length > 3 ? arguments[3] : undefined;
      var createAnalyticsEvent = arguments.length > 4 ? arguments[4] : undefined;
      _analyticsState.AnalyticsState.anonymousId = anonymousId;
      _analyticsState.AnalyticsState.createAnalyticsEvent = createAnalyticsEvent;

      // set load timestamp for calculating metrics
      _metrics.Metrics.setLoadTimestamp(loadTimestamp);
      // TODO: Switch these params to dynamically config based on writeKey
      _gtmIntegration.Gtm.initialize(writeKey);
      Initializer.captureUTMs();

      // adding marketing boolean if current product comes under marketing domain
      Initializer.setIsMarketingEvent(pageViewProperties);

      // store params for later reporting if necessary.
      _analyticsState.AnalyticsState.writeKey = writeKey;

      // auto-fire page view
      _helpers.Helpers.addActualUrl(pageViewProperties);
      _tracking.Tracking.pageView(pageViewProperties);

      // add auto tracking and configure google analytics integration
      Initializer.autoTrack();
      Initializer.gaIntegration();
      Initializer.globalCallReady();
    }

    /**
     * Calls window functions that are awaiting a wrapper ready state
     * @function globalCallReady
     */
  }, {
    key: "globalCallReady",
    value: function globalCallReady() {
      if (typeof window.analyticsPageReady === 'function') {
        window.analyticsPageReady();
      }
      _metrics.Metrics.logMetric(_metrics.MetricKey.TIME_TO_READY);
      _metrics.Metrics.sendMetrics();
    }
  }, {
    key: "captureUTMs",
    value: function captureUTMs() {
      var utmKeys = {
        utm_campaign: '',
        utm_medium: '',
        utm_source: '',
        utm_content: '',
        utm_term: ''
      };
      _analyticsState.AnalyticsState.utms = _helpers.Helpers.getUtms(utmKeys);
    }

    /**
     * Applies auto-tracking for select domains
     * @function autoTrack
     */
  }, {
    key: "autoTrack",
    value: function autoTrack() {
      _tracking.Tracking.autoTrackButtons(true);
      _tracking.Tracking.autoTrackLinks(true);
      _tracking.Tracking.autoTrackVideos();
      _tracking.Tracking.autoTrackSelects();
      _tracking.Tracking.autoTrackTabs();
    }

    /**
     * Completes path overrides for Google Analytics
     * @function gaIntegration
     */
  }, {
    key: "gaIntegration",
    value: function gaIntegration() {
      var emailDetected = _helpers.Helpers.emailAddressIsDetected();
      var pathOverride = '/path-contained-email-address';
      if (typeof window.ga !== 'undefined') {
        window.ga('require', 'linker');
        window.ga('linker:autoLink', ['atlassian.com', 'bitbucket.org', 'hipchat.com', 'attendease.com', 'get.atlassian.com', 'eegeventsite.secure.force.com', 'atlassian.swoogo.com']);
        if (emailDetected) {
          // only override what is needed
          if (_helpers.Helpers.urlContainsEmail(window.location.href)) {
            window.ga('set', 'location', window.location.origin + pathOverride);
            window.ga('set', 'path', pathOverride);
          }
          if (_helpers.Helpers.urlContainsEmail(document.referrer)) {
            window.ga('set', 'referrer', _helpers.Helpers.hostnameFromUrl(document.referrer) + pathOverride);
          }
        }
      }
    }
  }, {
    key: "setIsMarketingEvent",
    value: function setIsMarketingEvent(pageViewProperties) {
      if (typeof pageViewProperties['isMarketingEvent'] !== 'boolean') {
        _gasv.GASv3.isMarketingEvent = true;
      } else {
        _gasv.GASv3.isMarketingEvent = pageViewProperties['isMarketingEvent'];
      }
    }
  }, {
    key: "setXID",
    value: function setXID(xid) {
      _tracking.Tracking.xid = xid;
    }
  }]);
}();